import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { S3PresignedUrl } from 'src/app/classes/s3-presigned-url';

import { TemporaryHyperlink } from '../classes/models/temporary-hyperlink';

@Injectable({
  providedIn: 'root'
})
export class HyperlinkService {
  constructor(private http: HttpClient) {}

  getTemporaryHyperlink(query = {}) {
    return this.http.get<TemporaryHyperlink>(`/api/v2/public/hyperlink/one`, {
      params: query
    });
  }

  getTemporaryHyperlinkProposalRequestFilePresignedUrl({
    ProposalRequestId,
    FileId,
    hyperlinkHash
  }: {
    ProposalRequestId: number;
    FileId: number;
    hyperlinkHash: string;
  }) {
    return this.http.get<S3PresignedUrl>(
      `/api/v2/public/hyperlink/proposalRequestFile/presignedUrl`,
      { params: { ProposalRequestId, FileId, hyperlinkHash } }
    );
  }

  getTemporaryHyperlinkProposalFilePresignedUrl({
    ProposalRequestId,
    FileId,
    hyperlinkHash
  }: {
    ProposalRequestId: number;
    FileId: number;
    hyperlinkHash: string;
  }) {
    return this.http.get<S3PresignedUrl>(
      `/api/v2/public/hyperlink/proposalFile/presignedUrl`,
      { params: { ProposalRequestId, FileId, hyperlinkHash } }
    );
  }
}
